import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type InstructionStepsProps = {
  steps: string[];
  start?: number;
};

const InstructionSteps = ({ steps, start }: InstructionStepsProps) => (
  <Typography tag="div" variant="p-body3-multiline">
    <ol className={styles.steps} start={start}>
      {steps.map((step) => (
        <li key={step}>{step}</li>
      ))}
    </ol>
  </Typography>
);

export default InstructionSteps;
